export enum SocketEvent {
  MessageReceived = 'ReceiveMessageForUser',
  UserConnected = 'UserConnected',
}
